export class QueryParamsConstants {
    static readonly PLAY_ID = 'playId';
    static readonly ASSET_ID = 'assetId';
    static readonly ASSET_TYPE = 'assetType';
    static readonly FILE_NAME = 'fileName';
    static readonly UNIQUE_COLUMN_NAME = 'uniqueColumnName';
    static readonly HTTP_METHOD = 'httpMethod';
}
